export default function cache(fn, resolver) {
  let previousKey, previousValue;

  return function cached(...args) {
    let key = resolver.apply(null, args);
    if (key !== previousKey) {
      previousKey = key;
      previousValue = fn.apply(null, args);
    }
    return previousValue;
  };
}
